 import axios from 'axios';
import { authService } from '../services/authService';
import { message } from 'antd';

// 获取当前环境的 API 地址
const getApiBaseUrl = () => {
  // 如果是扫码页面，使用当前域名
  // if (window.location.pathname.startsWith('/ambassador/scan/')) {
  //   const protocol = window.location.protocol;
  //   const hostname = window.location.hostname;
  //   const port = process.env.REACT_APP_API_PORT || '3001';
  //   return `${protocol}//${hostname}:${port}/api`;
  // }
  
  // // 如果是移动端路径，使用配置的API地址
  // if (window.location.pathname.startsWith('/mobile/')) {
  //   return 'http://api.ddylcs.org.cn/api';
  // }
  
  // // 动态获取API地址
  // const protocol = window.location.protocol;
  // const hostname = window.location.hostname;
  // const port = process.env.REACT_APP_API_PORT || '3001';
  
  // 如果是通过IP访问，使用当前IP作为API地址
  // if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
  //   return `${protocol}//${hostname}:${port}/api`;
  // }
  
  // 其他情况使用环境变量或默认值
  return process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
};

// 创建带认证的axios实例
const instance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 创建不带认证的axios实例（用于扫码页面）
export const publicInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 统一使用token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，统一清除token
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // 根据当前路径跳转到对应登录页
          const currentPath = window.location.pathname;
          if (currentPath.startsWith('/responsible')) {
            if (currentPath !== '/responsible-login') {
              window.location.href = '/responsible-login';
            }
          } else if (currentPath.startsWith('/mobile/')) {
            if (currentPath !== '/mobile/login') {
              window.location.href = '/mobile/login';
            }
          } else {
            if (currentPath !== '/login') {
              window.location.href = '/login';
            }
          }
          break;
        case 403:
          message.error('没有权限访问该资源');
          break;
        case 404:
          message.error('请求的资源不存在');
          break;
        case 500:
          message.error('服务器错误');
          break;
        default:
          message.error(error.response.data?.message || '请求失败');
      }
    } else if (error.request) {
      message.error('网络错误，请检查您的网络连接');
    } else {
      message.error('请求配置错误');
    }
    return Promise.reject(error);
  }
);

export default instance; 